<template>
	<card title="Logs">
		<div class="sk-group" v-if="hasData">
			<div class="sk-group-list" v-for="item in collection" :key="item.id">
				<div class="sk-group-list-item">
					<div class="sk-group-list-item-value">
						<span>{{ getLogName(item.state_id) }}</span>
					</div>
					<div class="sk-group-list-item-day"><i class="sk-icon sk-icon-small sk-icon-day"></i> {{ getDay(item.create_time) }}</div>
					<div class="sk-group-list-item-hour"><i class="sk-icon sk-icon-small sk-icon-hour"></i> {{ getHour(item.create_time) }}</div>
				</div>
			</div>
		</div>
		<div class="sk-group sk-group-empty" v-if="!hasData">
			<div>{{ $t('Don\'t have readings to show.') }}</div>
		</div>
	</card>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import Card from '@/modules/common/Card'
import Datetime from '@/utils/Datetime'
export default {
	name: 'card-pacient-logs',
	components: {
		Card
	},
	props: {
		patient: {
			type: Object,
			default: () => ({})
		},
		datetime: {
			type: Object,
			default: () => ({
				minute: 0,
				hour: 0,
				day: 0,
				month: 0,
				year: 0
			})
		}
	},
	data() {
		return {
			collection: []
		}
	},
	computed: {
		hasData: function() {
			return this.collection.length > 0
		},
		...mapGetters({
			getCollection: 'PATIENTS_LOGS'
		}),
	},
	methods: {
		getLogName(value) {
			if (value == 1) return this.$t('Power up')
			if (value == 2) return this.$t('Power down')
			if (value == 3) return this.$t('Charging')
			if (value == 4) return this.$t('Low batterie')
			if (value == 5) return this.$t('Put in wrist')
			if (value == 6) return this.$t('Remove of wrist')
			if (value == 7) return this.$t('Call log')
			if (value == 8) return this.$t('Batterie update')
			return this.$t('Unknown')
		},
		getDay: (value) => moment(value).format('Do MMM'),
		getHour: (value) => moment(value).format('kk:mm'),
	},
	created() {
		this.collection = this.getCollection(this.patient)
	}
}
</script>

<style scope>

</style>



// WEBPACK FOOTER //
// src/modules/pacient/CardPacientLogs.vue